import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import { useModal } from '../../../../../hooks/useModal';
import { useWishes } from '../../../../../redux/reducer/content';
import { CLOTH, WISH } from '../../constants/types';

export default function useButtonCallbacks({ is_equipped, type, name, wishImage, wishTextId, id, elfImage }) {
  const { texts } = useWishes();
  const callbacks = useApplicationCallbacks();
  const { addModal } = useModal();

  return {
    onCloth() {
      type === CLOTH && !is_equipped && callbacks.equipItem(id);
    },
    onWish() {
      type === WISH &&
        addModal({
          type: 'myGiftImageModal',
          props: {
            images: [elfImage].filter(Boolean),
            is_black_text: wishImage?.is_black_text,
            title: '8march.congratulate8march',
            name,
            text: texts?.find(({ id }) => id === wishTextId)?.value,
          },
        });
    },
  };
}
